import React from 'react';
import './TimeFormatToggle.scss';
import { useGeneralSettings } from '../../../../hooks/useGeneralSettings';
import { TimeFormatType } from '@demind-inc/core';
import { CircularProgress, Divider, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const timeFormatOptions: { value: TimeFormatType; label: string }[] = [
  { value: '12h', label: '12h (Am/Pm)' },
  { value: '24h', label: '24h' },
];

const TimeFormatToggle = () => {
  const { t } = useTranslation();
  const {
    generalSettings: { timeFormat },
    handleGeneralSettingsChange,
    isPending,
  } = useGeneralSettings();

  const handleFormatChange = (format: TimeFormatType) => {
    handleGeneralSettingsChange({ timeFormat: format });
  };

  return (
    <div className="time-format-toggle">
      <div className="time-format-toggle__title">{t('settings.general.timeFormat')}</div>
      <div className="time-format-toggle__container">
        {isPending ? (
          <div className="time-format-toggle__loader">
            <CircularProgress size={16} />
          </div>
        ) : (
          <RadioGroup
            value={timeFormat}
            onChange={(event) => handleFormatChange(event.target.value as TimeFormatType)}
            className="time-format-toggle__radio-group"
          >
            {timeFormatOptions.map((option, index) => (
              <React.Fragment key={option.value}>
                <FormControlLabel
                  value={option.value}
                  control={
                    <Radio size="small" className="time-format-toggle__radio-item__control" />
                  }
                  label={
                    <Typography
                      variant="body2"
                      className="time-format-toggle__radio-item__label"
                    >
                      {option.label}
                    </Typography>
                  }
                  className={clsx('time-format-toggle__radio-item', {
                    'time-format-toggle__radio-item--selected': timeFormat === option.value,
                  })}
                />
                {index !== timeFormatOptions.length - 1 && (
                  <Divider
                    orientation="vertical"
                    flexItem
                    className="time-format-toggle__radio-item__divider"
                  />
                )}
              </React.Fragment>
            ))}
          </RadioGroup>
        )}
      </div>
    </div>
  );
};

export default TimeFormatToggle;
